import {useState} from "react";

import {CUSTOM_FONT_FAMILY} from "Theme";
import {Footer} from "base/layout";

import Link from "@mui/material/Link";
import LegalWarningDialog from "./LegalWarningDialog";

export const MainFooter = ({isFixed = false}) => {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const leftLinks = [
        <Link
            key={0}
            component="button"
            onClick={() => setOpen(true)}
            variant="subtitle2"
            underline="hover"
            rel="noopener noreferrer"
            sx={{
                textDecoration: "none",
                color: "white",
                fontFamily: CUSTOM_FONT_FAMILY,
                fontSize: "14px",
            }}
        >
            Legal notice
        </Link>,
    ];

    return (
        <>
            <LegalWarningDialog open={open} onClose={handleClose} />
            <Footer
                text="© 2025 ALL RIGHTS RESERVED · ReMAP"
                fontFamily={CUSTOM_FONT_FAMILY}
                position={isFixed ? "fixed" : "relative"}
                left={leftLinks}
            />
        </>
    );
};
